import angular from 'angular';
import '../../../components/input-spinner';

const module = angular.module('whyline.modals.add-physical-entries', [
  'whyline.components.inputSpinner',
]);

const AddPhisicalEntriesController = ($scope, $uibModalInstance, max) => {
  'ngInject';

  $scope.entries = 1;
  $scope.max = max;

  $scope.dismiss = () => {
    $uibModalInstance.close(false);
  };

  $scope.disabledConfirm = () => {
    return $scope.entries <= 0 || $scope.entries > $scope.max;
  }

  $scope.confirm = () => {
    $uibModalInstance.close($scope.entries);
  }

};

module.exports = module.controller('AddPhisicalEntriesController', AddPhisicalEntriesController);
